
type props = {
    children : string
    fontColor?: string
    borderColor? : string
    backgroundColor?: string
    callBackOnClick? : () => void 
    disable? : boolean
}

const Button : React.FC<props> = (props) => {

    const setCallBackFunction = props.callBackOnClick ? props.callBackOnClick : () => {}

    const btnStyle = {
        width: '100%',
        color: props.fontColor || '#FFFFFF',
        borderColor: props.borderColor || '#FF3363',
        backgroundColor: props.backgroundColor || '#FF3363',
        border: `1px solid ${props.borderColor || '#FF3363'}`,
        cursor: 'pointer',
        borderRadius: '15px',
        alignSelf: 'stretch',
        margin: '0.5rem 0px',
        padding: '1rem',
        fontSize: '1rem',
        fontFamily: 'Lato'
    }

    return (
        <button disabled={props.disable} onClick={setCallBackFunction} style={btnStyle}><span style={{fontWeight: '700'}}>{props.children}</span></button>
    )
}

export default Button